module.exports = __webpack_public_path__ + "static/media/coding.d79aa608.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/ai/icons/coding.gif
// module id = 3671
// module chunks = 0